module.exports = __webpack_public_path__ + "img/icn-lc-checked.6e3beb8f.png";